import { AxiosInstance } from 'axios';

export function createDashboardApi(client: AxiosInstance) {
  return {
    async getAdminAlerts(options?: { suppressAuthRedirect?: boolean }) {
      const response = await client.get('/admin/alerts', {
        suppressAuthRedirect: Boolean(options?.suppressAuthRedirect),
      } as any);
      return response.data;
    },
    async getDashboardStats(options?: { suppressAuthRedirect?: boolean }) {
      const response = await client.get('/admin/dashboard-stats', {
        suppressAuthRedirect: Boolean(options?.suppressAuthRedirect),
      } as any);
      return response.data;
    },
    async getSupervisorDashboard(weekStart?: string) {
      const response = await client.get('/supervisor/dashboard', {
        params: weekStart ? { week_start: weekStart } : undefined,
      });
      return response.data;
    },
    async setSupervisorHiddenEmployee(employeeId: number, hidden: boolean) {
      const url = `/supervisor/dashboard/hidden-employees/${employeeId}`;
      const response = hidden ? await client.put(url) : await client.delete(url);
      return response.data as { employee_id: number; hidden: boolean };
    },
    async getRfiAttentionSummary(options?: { suppressAuthRedirect?: boolean }) {
      const response = await client.get('/rfis/attention-summary', {
        suppressAuthRedirect: Boolean(options?.suppressAuthRedirect),
      } as any);
      return response.data;
    },
  };
}

export type DashboardApi = ReturnType<typeof createDashboardApi>;
